export default __webpack_public_path__ + "media/images/dividers/left-peaked-tear-cf78431a036fb9d17aa9c63ba58ba91d.svg";